export default class StringConstants {
  static ERROR_MESSAGE_GET_MEMBERSHIP_LEVELS(
    ERROR_MESSAGE_GET_MEMBERSHIP_LEVELS: any,
    TYPE_ERROR: any
  ) {
    throw new Error("Method not implemented.");
  }
  static SOMETHING_WENT_WRONG: any = "Something went wrong";

  static PARAM_FACILITY_ID = "facilityId";
  static PARAM_PARTNER_ID = "partnerId";
  static PARAM_BENEFIT_CONFIG_ID = "benefitConfigId";
  static PARAM_SERVICE_ID = "serviceId";
  static PARAM_BOOKING_ID = "bookingId";
  static PARAM_CATEGORY_ID = "categoryId";
  static PARAM_SERVICE_CONFIG_ID = "serviceConfigId";

  static PARAM_CITY_NAME = "cityName";
  static PARAM_CUISINE_NAME = "cuisineName";
  static PARAM_AMENITIES_NAME = "amenitesName";
  static PARAM_AREA_NAME = "areaName";
  static PARAM_SORTING_NAME = "sort";
  static PARAM_FEATURE_NAME = "isFeatured";

  static PARAM_LAT = "latitude";
  static PARAM_LONG = "longitude";

  static RedirectURL = "redirectUrl";
  static PARAM_DATA_ID = "dataId";
  static PARAM_DATA_TEMP_MEMBERSHIP_ID = "tempMembershipId";
  static PARAM_REFERENCE_ID = "reference_id";

  static PARAM_PROJECT_CODE = "projectCode";
  static PARAM_BENEFIT_GROUP = "benefitGroup";
  static PARAM_AUTH_TOKEN = "authToken";
  static PARAM_X_REGION = "param_x_region";
  static PARAM_TEMP_USERID = "param_temp_userid";
  static RETRY_PAYMENT = "retry";
  static FIRST_SCREEN = "firstScreen";
  static IS_SSO_LOGGED_IN = "isSSOLoggedIn";
  static SSO_LOGGED_IN_TOKEN = "SSOLoggedInToken";
}
